import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import {
  Calendar, Users, Edit3, Share2, Download, Sparkles, Trash2, Loader2, Compass, BookOpen, FileText, Wallet,
} from 'lucide-react';

export const TripActionBar = ({
  tripInput, status, generating, itineraryId,
  onModifyPlan, onEditTrip, onGenerate, onShare, onDownload, onDelete, onPublish,
}) => (
  <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-8 -mt-16 relative z-10" data-testid="trip-action-bar">
    <div className="flex flex-wrap items-center gap-4 bg-white/95 backdrop-blur-xl rounded-xl shadow-2xl p-4 border border-white/30">
      <span className="flex items-center gap-2 text-ocean bg-ocean/10 px-4 py-2 rounded-full">
        <Calendar className="w-4 h-4 text-ocean" />
        <span className="font-mono text-sm font-semibold">
          {tripInput.start_date} &rarr; {tripInput.end_date}
        </span>
      </span>
      <span className="w-px h-6 bg-ocean/20 hidden md:block" />
      <span className="flex items-center gap-2 text-ocean bg-sky/10 px-4 py-2 rounded-full">
        <Users className="w-4 h-4 text-sky" />
        <span className="font-medium">
          {tripInput.traveler_type} &bull; {tripInput.adults} adults
          {tripInput.kids > 0 && `, ${tripInput.kids} kids`}
        </span>
      </span>
    </div>

    <div className="flex flex-col gap-2">
      {status !== 'completed' && (
        <div className="flex flex-wrap gap-3">
          <Button className="bg-white/90 hover:bg-white text-ocean border border-ocean/20 px-6 py-3 rounded-full font-sans font-semibold transition-all duration-200 hover:shadow-xl active:scale-95 backdrop-blur-sm" onClick={onModifyPlan} data-testid="modify-plan-btn">
            <Edit3 className="w-4 h-4 mr-2" /> Modify Plan
          </Button>
          <Button className="bg-gold hover:bg-gold-light text-ocean px-6 py-3 rounded-full font-sans font-semibold transition-all duration-200 hover:shadow-xl active:scale-95 shadow-lg" onClick={onGenerate} disabled={generating} data-testid="generate-btn">
            {generating ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Sparkles className="w-4 h-4 mr-2" />Generate Itinerary</>}
          </Button>
          <Button className="bg-red-500/90 hover:bg-red-600 text-white px-6 py-3 rounded-full font-sans font-semibold transition-all duration-200 hover:shadow-xl active:scale-95 backdrop-blur-sm" onClick={onDelete} data-testid="delete-itinerary-btn">
            <Trash2 className="w-4 h-4 mr-2" /> Delete Trip
          </Button>
        </div>
      )}
      {status === 'completed' && (
        <>
          {/* Row 1: Edit, Share, Download, Delete */}
          <div className="flex flex-wrap gap-2">
            <Button className="bg-ocean/90 hover:bg-ocean text-white px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 backdrop-blur-sm" onClick={onEditTrip} data-testid="edit-trip-btn">
              <Edit3 className="w-4 h-4 mr-1.5" /> Edit Trip
            </Button>
            <Button className="bg-gold hover:bg-gold-light text-ocean px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 shadow-lg" onClick={onShare} data-testid="social-share-btn">
              <Share2 className="w-4 h-4 mr-1.5" /> Share
            </Button>
            <Button className="bg-white/90 hover:bg-white text-ocean border border-ocean/20 px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 backdrop-blur-sm" onClick={onDownload} data-testid="download-btn">
              <Download className="w-4 h-4 mr-1.5" /> Download
            </Button>
            <Button className="bg-red-500/90 hover:bg-red-600 text-white px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 backdrop-blur-sm" onClick={onDelete} data-testid="delete-itinerary-btn">
              <Trash2 className="w-4 h-4 mr-1.5" /> Delete Trip
            </Button>
          </div>
          {/* Row 2: Track Budget, Trip Story, Blog, Publish */}
          <div className="flex flex-wrap gap-2">
            <Link to={`/itinerary/${itineraryId}/budget`}>
              <Button className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 shadow-lg" data-testid="track-budget-btn">
                <Wallet className="w-4 h-4 mr-1.5" /> Track Budget
              </Button>
            </Link>
            <Link to={`/itinerary/${itineraryId}/timeline`}>
              <Button className="bg-gradient-to-r from-gold to-amber-400 text-ocean px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 shadow-lg" data-testid="trip-story-btn">
                <BookOpen className="w-4 h-4 mr-1.5" /> Trip Story
              </Button>
            </Link>
            <Link to={`/itinerary/${itineraryId}/blog`}>
              <Button className="bg-gradient-to-r from-ocean-light to-sky text-white px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 shadow-lg" data-testid="create-blog-btn">
                <FileText className="w-4 h-4 mr-1.5" /> Blog
              </Button>
            </Link>
            <Button className="bg-sky hover:bg-sky/90 text-white px-4 py-2.5 rounded-full font-sans font-semibold text-sm transition-all duration-200 hover:shadow-xl active:scale-95 shadow-md" onClick={onPublish} data-testid="publish-template-btn">
              <Compass className="w-4 h-4 mr-1.5" /> Publish
            </Button>
          </div>
        </>
      )}
    </div>
  </div>
);
